import {QueryClient} from '@tanstack/react-query'
import {AxiosResponse} from 'axios'
import {GET_ENDPOINTS_QUERY_KEY} from 'features/Endpoints/hooks/useEndpointsQuery'
import {
  ContextualPrefetchType,
  PrefetchContextEnum,
  PrefetchQueryFnEnum,
  EndpointRoutesEnum,
  EndpointsSearchResponse,
} from 'interfaces'

/**
 * Prewarm select and search endpoint API's
 * @param {queryClient} queryClient - current react-query client
 * @param {prefetch} prefetch - contextual prefetch function from useContextualPrefetch
 * @returns {void}
 */
const prewarmEndpoints = (
  queryClient: QueryClient,
  prefetch: ({route, context, payload}: ContextualPrefetchType) => void,
): void => {
  const data = queryClient.getQueryData<{
    pages: AxiosResponse<EndpointsSearchResponse>[]
    pageParams: unknown[]
  }>([
    GET_ENDPOINTS_QUERY_KEY,
    {
      first: 100,
    },
  ])

  // Get first endpoint item
  const firstItem = data?.pages?.[0]?.data?.data?.endpoints?.[0]
  if (firstItem) {
    prefetch({
      route: EndpointRoutesEnum.BASE,
      context: PrefetchContextEnum.MOUNT,
      payload: {
        [PrefetchQueryFnEnum.WARM_ENDPOINT_DIAGNOSTICS]: {
          agent: firstItem.agentUUID,
        },
        [PrefetchQueryFnEnum.WARM_ASSOCIATED_USERS]: {
          agentUUID: firstItem.agentUUID,
        },
      },
    })
  }
}

export default prewarmEndpoints
